import { addItemToBasket, removeItemFromBasket, selectBasketCheckPriceItem, selectBasketDeliveries, selectBasketItem, selectBasketToPay, updateBasketItem, updateDelivery } from 'containers/OrderDetails/basketSlice'
import useOpeningMethodData from '../hooks/useOpeningMethodData'
import DeliveryPopup from 'components/popups/DeliveryPopup'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import placeholder from 'assets/img/placeholder.png'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import Popup from 'components/popups/Popup'
import { displayPrice } from 'utils/string'
import Loading from 'components/Loading'
import Error from 'components/Error'
import { useState } from 'react'

const LockPopup = ({ addToGate = false, method, selectedItems }) => {
  const { id } = useParams()
  const toPay = useSelector(selectBasketToPay)
  const deliveries = useSelector(selectBasketDeliveries)
  const recentlySelectedDeliveries = useSelector(selectBasketDeliveries)
  const selectedBasketItem = useSelector(state => selectBasketItem(state, id))
  const { placeAddress } = useSelector(state => selectBasketCheckPriceItem(state, id))
  const isSomethingSelected = selectedItems && selectedItems.length > 0
  const [page, setPage] = useState({ type: isSomethingSelected ? 'selectedOptions' : 'availableOptions' })
  const { isLoading, padlockInfo } = useOpeningMethodData(
    method.id,
    // isSomethingSelected
    //   ? undefined
    //   : (data) => {
    //     setPage({
    //       type: 'delivery',
    //       data
    //     })
    //   }
  )

  const dispatch = useDispatch()
  const { goBack } = useHistory()
  const { t } = useTranslation('delivery')

  if (page.type === 'delivery') {
    return (
      <DeliveryPopup
        placeAddress={placeAddress}
        delivery={page.data?.delivery}
        productName={page.data?.name || method?.name}
        price={page.data?.grossPrice || method?.grossPrice}
        deliveryMethods={page.data?.deliveryMethods || method.deliveryMethods}
        recentlySelectedDeliveries={recentlySelectedDeliveries}
        setRecentlySelectedDeliveries={(getState) => {
          const state = typeof getState === 'function' ? getState(recentlySelectedDeliveries) : getState
          dispatch(updateDelivery(state))
        }}
        cancelAction={() => {
          setPage({ type: page.prev || 'availableOptions' })
        }}
        callback={values => {
          // update
          if (page.data?.cartId) {
            dispatch(updateBasketItem({ identifier: page.data.cartId, values }))

            // add new
          } else {
            const value = {
              type: 'rentAddon',
              id: method.id,
              placeId: selectedBasketItem.placeId,
              name: page.data.name || method.name,
              openingMethodKey: method.openingMethodKey,
              depositAmount: method.depositAmount,
              object: page.data.object,
              objectId: page.data.id,
              ...values
            }
            if (!addToGate) {
              value.ownerId = selectedBasketItem.identifier
            }
            dispatch(addItemToBasket(value))
          }
          setPage({ type: 'selectedOptions' })
        }}
      />
    )
  }

  return (
    <Popup darkBg={true}>
      {isLoading
        ? <Loading />
        : <>
          <div className='popup__title'>
            <div>{page.type === 'selectedOptions' && isSomethingSelected ? method?.name : (method?.nameForClient || method?.name)}</div>
          </div>

          {page.type === 'selectedOptions' && isSomethingSelected
            ? <div className='popup__padlock'>
              {method.openingMethodKey === 'our_padlock' && <div className='popup__padlock__info'>
                <h2>{t('accessWithPadlock')}</h2>
                <p>{method?.howToForClient || t('storageRequiresPadlock')}</p>
              </div>}

              <div className='popup__padlock__items'>
                <h2>
                  {t('selectedAccessDevices')}
                </h2>
                {selectedItems.map((selected) => {
                  const data = padlockInfo?.find(info => info.id === selected.objectId)
                  const delivery = (selected?.deliveryId && deliveries) ? deliveries.find(d => d.id === selected.deliveryId) : undefined
                  const toPayData = (toPay && selected?.identifier) ? toPay[selected.identifier] : undefined
                  if (!data) return null
                  return <div
                    key={selected?.identifier}
                    className='popup__padlock__item checked'>
                    <div className='popup__padlock__item__image'>
                      <img
                        alt={data?.name}
                        src={data?.image_url || placeholder}
                      />
                    </div>
                    <div className='popup__padlock__item__content'>
                      <h3>{data?.name}</h3>
                      {toPayData?.to_pay?.depositAmount && <div>{t('deposit')}: <b>{displayPrice(toPayData?.to_pay?.depositAmount)}</b></div>}
                      {delivery?.type && <div>{t('delivery')}: <b>{t(delivery?.type)}</b></div>}
                      {toPayData?.to_pay?.price_sum
                        ? <div>{t('amountToPay')}: <b>{displayPrice(toPayData?.to_pay?.price_sum)}</b></div>
                        : data?.grossPrice
                          ? <div>{t('price')}: <b>{displayPrice(data?.grossPrice)}</b></div>
                          : null}
                    </div>
                    <div className='popup__padlock__item__actions'>
                      {selected && <i
                        className='icon icon--rename'
                        onClick={() => {
                          setPage({
                            type: 'delivery',
                            prev: 'selectedOptions',
                            data: {
                              ...data,
                              cartId: selected.identifier,
                              delivery
                            }
                          })
                        }} />}
                      <i
                        className='icon icon--trash'
                        onClick={() => {
                          dispatch(removeItemFromBasket({ removeIdentifiers: [selected.identifier] }))
                        }} />
                    </div>
                  </div>
                })}
              </div>

              {(padlockInfo.length > 1 || (padlockInfo[0].maxAmount && padlockInfo[0].maxAmount > 1)) && <div
                className='btn'
                onClick={() => {
                  setPage(
                    padlockInfo.length === 1
                      ? { type: 'delivery', data: padlockInfo[0], prev: 'selectedOptions' }
                      : { type: 'availableOptions' }
                  )
                }}>
                <i className='icon icon--plus2' />
                {t('addAccessDevice')}
              </div>}

              <ArrowBtn
                enlarged
                showArrow={false}
                text={t('ready')}
                action={goBack}
              />
            </div>
            : <div className='popup__padlock'>
              {method.openingMethodKey === 'our_padlock' && <div className='popup__padlock__info'>
                <h2>{t('accessWithPadlock')}</h2>
                <p>{t('storageRequiresPadlock')}</p>
              </div>}

              <div className='popup__padlock__items'>
                <h2>
                  {t('selectAccessDevice')}
                </h2>
                {padlockInfo
                  ? padlockInfo.map((data) => {
                    const { id, name, grossPrice, image_url } = data
                    return <div
                      key={id}
                      className='popup__padlock__item'
                      onClick={() => {
                        setPage({ type: 'delivery', data, prev: 'availableOptions' })
                      }}>
                      <div className='popup__padlock__item__image'>
                        <img
                          alt={name}
                          src={image_url || placeholder}
                        />
                      </div>
                      <div className='popup__padlock__item__content'>
                        <h3>{name}</h3>
                        <div>{t('price')}: <b>{displayPrice(grossPrice)}</b></div>
                      </div>
                      <div className='popup__padlock__item__actions'>
                        <div className='checkCircle'>
                          <i className='icon icon--check' />
                        </div>
                      </div>
                    </div>
                  })
                  : <Error staticPos />}
              </div>

              <ArrowBtn
                enlarged
                disabled={!isSomethingSelected}
                showArrow={false}
                text={t('ready')}
                action={goBack}
              />
            </div>}
        </>}
    </Popup>
  )
}

export default LockPopup